import React from 'react';
import _ from "lodash";

export default class FilterProto {

    public filtersManager   : any
    public filterConfig     : any
    public field            : ID   // uuu .... mmm.... is it ID ?
    public label            : string
    public value            : any
    public isEnabled        : boolean   = false
    public filterComponent  : any
    public isOpen           : boolean    = false
    public isVisible        : boolean    = false
    public isCustomField    : boolean    = false
    public optionsSet       : Set<any>

    constructor(filtersManager:any, filterConfig:any, initValue:any, label:string) {

        this.filtersManager = filtersManager;

        this.filterConfig   = filterConfig;

        this.field = (filterConfig.customField)?filterConfig.customField.id:filterConfig.field;         // field name system or custom

        this.label = label;
        this.value = initValue?initValue:null;

        this.isEnabled = false;              // true if hase value and used in filtering bad name .. is Active is meaning
        // this.isHidden = true;                       // hidden = minimized, visible = visible
        this.filterComponent = null;                // link to filter component in right panel
        this.isOpen = false;               // collapsed / expanded view in fieters pane
        // this.key = field;           // used in react render
        this.isVisible = false;         // true if filter is selected in filters panel and may be without any value selected/entered yet

        // auto open if value set
        if (!!initValue) {
            // this.isHidden = false;
            this.isOpen = true;
            this.isEnabled = true;
            this.isVisible = true;
            this.filtersManager.visibleFilters.push(this);
        }

        this.isCustomField = false;

        this.optionsSet = new Set();

    }

    reset(silent=false) {
        this.setValue(null, silent);
    }

    setValue(val:any, silent=false) {
        // console.log("filter changed", val, "silent=", silent);
        this.value = val

        this.filterComponent?.update()
        !silent && this.filtersManager.onChange(this)
    }

    getValue() {
        return this.value;
    }

    // // eto stupid mega hack - ubivanie function zachem potomu chto gde to eto proveryaut a parent class has it as a methong!!
    // Vic need to thing - est' proverka na false - i.e. existantce of this method - mozet prosto ubra't ego otsuad?
    optionsFillerFunc(dataItem:any) {
        console.error("optionsFillerFunc not implemented");
    }

    filterFunc(dataItem:any) {
        console.error("filterFunc not implemented");
    }

    // visibility
    setVisible() {
        this.isVisible = true;
        this.isOpen = true;
        this.filtersManager.visibleFilters.push(this);
    }

    setInvisible(silent: boolean = false ) {
        this.isVisible = false
        this.isOpen = false
        this.reset(silent)
        this.filtersManager.visibleFilters.remove(this)
    }

    toggleIsOpen(forceValue:any) {
        let newValue;

        if (forceValue===true) {
            newValue = true;
        } else if (forceValue===false) {
            newValue = false;
        } else {
            newValue = !this.isOpen;
        }

        if (this.isOpen === newValue) return;

        this.isOpen = newValue;
        if (this.filterComponent) this.filterComponent.setState({isOpen: newValue })
    }

    toObject() {
        return this.value;
    }

    // depricated
    valueChecker(a:any, b:any, strict = false){
        const { checkIsArray } = gd.utils;
        let result;
        if (checkIsArray(b)) {
            if (checkIsArray(a)) {
                result = strict ? _.intersection(b,a).length === b.length : _.intersection(b,a).length > 0;
            } else {
                result = b.includes(a);
            }
        } else {
            result = checkIsArray(a) ? a.includes(b) : b === a;
        }
        return result;
    }

    render() {
        return <div>I'm filter</div>
    }

    renderPill() {
        return <div className="gd-field-pill size-26">{this.label}</div>
    }

}